import '../styles/About.css';

function About() {
  const team = [
    {
      name: 'Leadership Team',
      title: 'Chartered Management Consultants',
      bullets: [
        'Decades of experience in operational excellence and process improvement',
        'Organisational transformation specialists',
        'CMC chartered status — highest professional standards'
      ],
      image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop&crop=face'
    },
    {
      name: 'Expert Consultants',
      title: 'Lean Six Sigma Green Belts',
      bullets: [
        'Certified practitioners in identifying and eliminating inefficiencies',
        'Combine Lean methods with structured, data-led problem solving',
        'Deliver measurable results across all sectors'
      ],
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=face'
    },
    {
      name: 'Implementation Specialists',
      title: 'Change Management Experts',
      bullets: [
        'Ensure improvements are embedded and sustained',
        'Build your team\'s capability for long-term success',
        'Changes that stick — not short-term fixes'
      ],
      image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop&crop=face'
    }
  ];

  const industries = [
    'Manufacturing',
    'Construction',
    'Financial Services',
    'Healthcare',
    'Logistics',
    'Professional Services',
    'Technology',
    'Operations and Production'
  ];

  return (
    <div className="about">
      {/* Header with background image */}
      <section className="about-header">
        <div className="about-header-overlay"></div>
        <div className="about-header-content">
          <h1 className="about-title">About CKS Innovation</h1>
          <p className="about-intro">
            Building organizations that improve continuously
          </p>
        </div>
      </section>

      {/* Mission Section with image */}
      <section className="mission">
        <div className="mission-container">
          <div className="mission-content">
            <h2>Our Mission</h2>
            <ul className="bullet-list">
              <li>Help organizations unlock their full operational potential</li>
              <li>Systematic improvement and strategic consulting</li>
              <li>Enable sustainable competitive advantage</li>
            </ul>
          </div>
          <div className="mission-content">
            <h2>Our Vision</h2>
            <ul className="bullet-list">
              <li>World-class consulting accessible to organisations of all sizes</li>
              <li>Build cultures of continuous improvement</li>
              <li>Drive growth, profitability, and employee engagement</li>
            </ul>
          </div>
        </div>
        <div className="mission-image-strip">
          <img
            src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&h=400&fit=crop"
            alt="Modern office workspace"
            className="mission-strip-img"
          />
        </div>
      </section>

      {/* Values Section */}
      <section className="values">
        <div className="values-container">
          <h2 className="values-heading">Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <h3>Excellence</h3>
              <ul className="bullet-list">
                <li>Highest quality work</li>
                <li>Rigorous methodology and proven best practices</li>
              </ul>
            </div>
            <div className="value-card">
              <h3>Integrity</h3>
              <ul className="bullet-list">
                <li>Highest ethical standards</li>
                <li>Complete transparency in all engagements</li>
              </ul>
            </div>
            <div className="value-card">
              <h3>Partnership</h3>
              <ul className="bullet-list">
                <li>Work collaboratively with clients</li>
                <li>Treat client success as our own</li>
              </ul>
            </div>
            <div className="value-card">
              <h3>Innovation</h3>
              <ul className="bullet-list">
                <li>Continuously evolve our methodologies</li>
                <li>Reflect the latest thinking in organisational improvement</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section with photos */}
      <section className="team">
        <div className="team-container">
          <h2 className="team-heading">Our Team</h2>
          <div className="team-grid">
            {team.map((member, index) => (
              <div key={index} className="team-card">
                <div className="team-photo-wrapper">
                  <img src={member.image} alt={member.name} className="team-photo" />
                </div>
                <h3 className="team-name">{member.name}</h3>
                <p className="team-title">{member.title}</p>
                <ul className="team-description bullet-list">
                  {member.bullets.map((bullet, i) => (
                    <li key={i}>{bullet}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Story Section with image */}
      <section className="story">
        <div className="story-container">
          <div className="story-text">
            <h2>Our Story</h2>
            <ul className="bullet-list">
              <li>Founded on the principle that operational excellence is achievable for any organization</li>
              <li>Chartered management consultants with deep expertise in Lean, Six Sigma, and organisational transformation</li>
              <li>Helping organizations solve their toughest operational challenges</li>
              <li>Build internal capability to improve continuously without external support</li>
            </ul>
          </div>
          <div className="story-image-wrapper">
            <img
              src="https://images.unsplash.com/photo-1531973576160-7125cd663d86?w=600&h=500&fit=crop"
              alt="Team collaboration and planning"
              className="story-image"
            />
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="industries">
        <div className="industries-container">
          <h2>Industries We Serve</h2>
          <ul className="bullet-list">
            <li>Work with organizations across operationally complex sectors</li>
            <li>If you have processes, workflows, or teams that need improvement, we can help</li>
          </ul>
          <div className="industries-grid">
            {industries.map((industry, index) => (
              <div key={index} className="industry-tag">
                {industry}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
